import { useEffect } from 'react';
import { Link, useNavigate } from '@tanstack/react-router';

import { Loading } from '@/components/loading/Loading';
import { clearPersistStorage } from '@/services/query-client/QueryClient';

import styles from './Callback.module.css';
import { useCallback } from './Callback.hooks';

export const Callback = () => {
	const navigate = useNavigate();
	const { isLoading, error, isSubscribed, url } = useCallback();
	useEffect(() => {
		if (isLoading) {
			return;
		}

		if (!url) {
			return;
		}
		const promises: Array<Promise<any>> = [clearPersistStorage()];
		Promise.all(promises)
			.then(() => {
				navigate({
					to: url,
					replace: true,
				});
			})
			.catch(() => {
				navigate({
					to: url,
					replace: true,
				});
			});
	}, [isLoading, url]);
	if (error) {
		return <div className={styles['error']}>{error.message}</div>;
	}
	if (isLoading) {
		return (
			<div className={styles['loading']}>
				<Loading />
			</div>
		);
	}

	if (!isSubscribed) {
		return <SubscriptionRequired />;
	}
	return <div>Callback</div>;
};

function SubscriptionRequired() {
	return (
		<div className={styles['subscription-required']}>
			<section>
				<h1>Login Successful</h1>
				<h2>A valid subscription is required to access this content</h2>

				<Link to={'/subscriptions'}>Purchase Subscription</Link>
				<p>
					Or <Link to={'/'}>Return to Magazine</Link>
				</p>
			</section>
		</div>
	);
}
